import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import { discardDirtyForms, useDirtyStatus } from '../utils/dirtyGuard';
export default function ScopeNavigationGuard() {
  const dirty = useDirtyStatus();
  const blocker = useBlocker(({ currentLocation, nextLocation }) => dirty
    && (currentLocation.pathname !== nextLocation.pathname || currentLocation.search !== nextLocation.search));
  useEffect(() => {
    const unload = (event: BeforeUnloadEvent) => { if (dirty) { event.preventDefault(); event.returnValue = ''; } };
    window.addEventListener('beforeunload', unload); return () => window.removeEventListener('beforeunload', unload);
  }, [dirty]);
  if (blocker.state !== 'blocked') return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40" role="presentation">
    <section role="alertdialog" aria-modal="true" aria-labelledby="scope-dirty-title" className="rounded-xl bg-white p-6 shadow-xl">
      <h2 id="scope-dirty-title" className="font-semibold">Unsaved changes</h2>
      <p className="my-4">Stay to keep editing, or discard your changes and continue.</p>
      <button type="button" autoFocus className="mr-3 rounded border px-4 py-2" onClick={() => blocker.reset()}>Stay</button>
      <button type="button" className="rounded bg-slate-900 px-4 py-2 text-white" onClick={() => { discardDirtyForms(); blocker.proceed(); }}>Discard</button>
    </section>
  </div>;
}
